//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import OrdererListView from '@/views/Warehouse/WhOrderer/list'
import OrdererProcessView from '@/views/Warehouse/WhOrderer/process'
import OrdererUpdateView from '@/views/Warehouse/WhOrderer/update'
import OrdererUnprocessedView from '@/views/Warehouse/WhOrderer/unprocessed'

//
export default {
    path: 'orderers',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'orderer-list',
            component: OrdererListView,
        },
        {
            path: 'unprocessed',
            name: 'orderer-unprocessed',
            component: OrdererUnprocessedView,
            meta: {
                title: 'Solicitudes de abastecimiento sin procesar',
            },
        },
        {
            path: ':id',
            name: 'orderer-update',
            component: OrdererUpdateView,
            meta: {
                title: 'Detalle de solicitudes de abastecimiento',
            },
        },
        {
            path: ':id/process',
            name: 'orderer-process',
            component: OrdererProcessView,
            meta: {
                title: 'Procesar solicitud de abastecimiento',
            },
        },
    ],
    meta: {
        title: 'Solicitudes de abastecimiento',
    },
}
